(ns client-portal.client.main
  (:require [reagent.dom :as rdom]
            [shared.core.reactive :as re]
            [shared.core.data :as shared.d]
            [shared.core.form]
            [shared.core.config :as config]
            [shared.core.timer]
            [client-portal.client.root :as root]
            [client-portal.client.router :as router]
            [shared.core.components.google-maps.data]
            [shared.core.util :as util]
            [shared.core.thirdparty.datadog]
            [shared.core.debug.data]
            [shared.core.components.auth0.data]
            [client-portal.client.account.data]
            [client-portal.client.concepts.data]
            [client-portal.client.cohorts.data]
            [client-portal.client.locations.data]))

(def root-path (util/ns->keyword-path ::root))

(defn dev-setup []
  (when @config/debug?*
    (println "dev mode")))

(re/reg-sub
  :core/mobile-layout?-
  (fn [db]
    (not (shared.d/breakpoint-min? db :md))))

(defonce app-root* (atom nil))

(defn ^:dev/after-load mount-root []
  (when @(re/subscribe [:debug/app-rerender-on-load?])
    (re/clear-subscription-cache!)
    (let [root-el (.getElementById js/document "app")]
      (rdom/render [root/current-root-view] root-el))))

(defn init []
  (util/conditionally-enabled-devtools-dark-mode)
  (re/dispatch-sync [:core/initialize])
  (re/dispatch-sync [:core/bind-window-events])
  (re/dispatch-sync [:core/set-window-defaults])
  (re/dispatch-sync [:thirdparty/datadog-init {:service "client-portal"}])
  (router/start!)
  (dev-setup)
  (mount-root))
